
/** 
 * @param {string} checkboxId unique id of checkbox
 * @param {string} checkboxLabel Text in label
 * @param {string} checkboxValue Value of checkbox
 * @param {string} checkboxAriaLabel Aria label for the checkbox
 * @param {string} bootstrapSize
 * @param {boolean} renderAsInline if true, checkbox rendes as inline
 * @param {function} handleChange
 * @param {bool} checkboxChecked
 */
function Checkbox(props){
    if(props.checkboxId === undefined || props.checkboxId === null){
        return null;
    }

    let inline = "";
    if(props.renderAsInline){
        inline = " form-check-inline";
    }

    let elementSizeClassName = "";
    if(props.bootstrapSize !== undefined){
        elementSizeClassName = props.bootstrapSize;
    }

    return (
        <div className={elementSizeClassName + " form-check" + inline}>
            <input className="FormChoice__Input FormChoice__Input--Checkbox" type="checkbox" 
                value={props.checkboxValue} 
                id={props.checkboxId}
                checked={props.checkboxChecked}
                onChange={e => {
                    props.handleChange(e.target.checked);
                }}
                tabIndex="-1"
                aria-label={props.checkboxAriaLabel}
            />
            <label className="FormChoice__Label" htmlFor={props.checkboxId}
                tabIndex="0"
                onKeyDown={e => {
                    if(e.code === 'Space' || e.keyCode === 32){
                        e.preventDefault();
                        props.handleChange(e.target.checked);
                    }
                }}
            >
                {props.checkboxLabel}
            </label>
        </div>
    )
}
export default Checkbox;